// export function linspace(
//   start: number,
//   stop: number,
//   num: number,
//   endpoint: boolean = true,
// ): number[] {
//   const div = endpoint ? num - 1 : num;
//   const step = (stop - start) / div;
//   return Array.from({ length: num }, (_, i) => start + step * i);
// }

import { useMarketStore } from '@/store/use-markets-store';
import { TimeInForce } from '@/types';
import {
  formatBigInt,
  parseDecimalToBigInt,
  parseInputToDecimalStr,
} from '@/utils/value-format';

export function rangeCount(
  start: number,
  stop: number,
  count: number,
  maxDecimals: number,
): number[] {
  if (count <= 1) return [start];
  const step = (stop - start) / (count - 1);
  return Array.from({ length: count }, (_, i) => {
    const value = start + step * i;
    return Number(value.toFixed(maxDecimals)); // Rounds to 2 decimal places
  });
}

export const getIsTaker = (timeInForce?: TimeInForce) => {
  switch (timeInForce) {
    case TimeInForce.ALO:
      return false;
    default:
      return true;
  }
};

type ValidateLimitPriceOptions = {
  forceTickSize?: boolean;
};

export const validateLimitPrice = (
  symbol: string,
  limitPrice: string,
  options: ValidateLimitPriceOptions = {},
) => {
  const { marketSpec } = useMarketStore(symbol).getState();
  if (!limitPrice.includes('.') && !options.forceTickSize) return limitPrice;

  const tickSize = marketSpec.tickSizes.at(0);
  if (!tickSize) return limitPrice;
  if (!tickSize.includes('.') || tickSize.endsWith('1')) return limitPrice;

  const minTickDigits = tickSize.split('.').pop()?.length ?? 0;
  const priceDigits = limitPrice.includes('.')
    ? limitPrice.split('.').pop()?.length ?? 0
    : 0;

  if (!options.forceTickSize && minTickDigits !== priceDigits) {
    return limitPrice;
  }

  let parsedLimitPrice = parseDecimalToBigInt(
    limitPrice,
    marketSpec.priceDecimals,
  );

  const step = tickSize.endsWith('.')
    ? 1n
    : BigInt(tickSize.replace(/^.*?(?=[1-9]\d*$)/, ''));
  const remainder = parsedLimitPrice % step;
  if (remainder !== 0n) {
    if (remainder * 2n >= step) {
      parsedLimitPrice = parsedLimitPrice + (step - remainder);
    } else {
      parsedLimitPrice = parsedLimitPrice - remainder;
    }
    return formatBigInt(parsedLimitPrice, marketSpec.priceDecimals, {
      digits: Number(marketSpec.priceDecimals),
      commas: false,
    });
  }

  return formatBigInt(parsedLimitPrice, marketSpec.priceDecimals, {
    digits: priceDigits,
    commas: false,
  });
};

export const validateFinalLimitPrice = (symbol: string, limitPrice: string) => {
  const { marketSpec } = useMarketStore(symbol).getState();
  return parseInputToDecimalStr(
    validateLimitPrice(symbol, limitPrice, { forceTickSize: true }),
    marketSpec.priceDecimals,
  );
};

export const validateOptionalFinalLimitPrice = (
  symbol: string,
  limitPrice?: string,
) => {
  if (!limitPrice) return undefined;
  return validateFinalLimitPrice(symbol, limitPrice);
};
